// L'ANTIALIASING È DI QUATTRO INTERRUTTORI, non di uno: due dispositivi, e per ognuno se vale anche
// MENTRE SI GIRA il modello — che è il momento in cui costa, perché lì si ridisegna a ogni
// fotogramma. La forma è quella del motore (`SceneAntiAliasingConfig`), non una nostra invenzione.
//
// NON SI VEDE SUBITO, ed è così da sempre: l'antialiasing lo monta il viewer quando prepara la
// scena, e non c'è un setter che lo accenda a caldo. Qui si scrive la scena, non il fotogramma.
export type AntiAliasDevice = { enabled: boolean; inRotationEnabled: boolean };
export type AntiAliasConfig = { desktop: AntiAliasDevice; mobile: AntiAliasDevice };

export const ANTIALIAS_OFF: AntiAliasConfig = { desktop: { enabled: false, inRotationEnabled: false }, mobile: { enabled: false, inRotationEnabled: false } };
export const ANTIALIAS_ON: AntiAliasConfig = { desktop: { enabled: true, inRotationEnabled: false }, mobile: { enabled: true, inRotationEnabled: false } };

// SI LEGGE CAMPO PER CAMPO, non si passa avanti l'oggetto trovato: quello che torna dal server è
// JSON, e una scena vecchia può non avere una delle due metà. Riscrivere poi un oggetto a metà nel
// config vorrebbe dire rimandarlo al salvataggio così com'è.
export const readAntiAlias = (sceneEditor: any): AntiAliasConfig => {
    const stored = sceneEditor?.getSceneConfig?.()?.toJSON?.()?.general?.antialias;
    if (!stored) return ANTIALIAS_OFF;
    return {
        desktop: { enabled: stored.desktop?.enabled ?? false, inRotationEnabled: stored.desktop?.inRotationEnabled ?? false },
        mobile: { enabled: stored.mobile?.enabled ?? false, inRotationEnabled: stored.mobile?.inRotationEnabled ?? false }
    };
};

export const writeAntiAlias = (sceneEditor: any, next: AntiAliasConfig) => {
    const generalConfig = sceneEditor?.getSceneConfig?.()?.get?.('general');
    const AntiAliasingConfig = (window as any).Zakeke?.SceneAntiAliasingConfig;
    if (generalConfig && AntiAliasingConfig) generalConfig.set('antialias', new AntiAliasingConfig(next));
};

/** Acceso se almeno un dispositivo lo è: l'interruttore del gruppo non ha uno stato suo. */
export const isAntiAliasOn = (config: AntiAliasConfig) => config.desktop.enabled || config.mobile.enabled;

// SPEGNERE UN DISPOSITIVO SPEGNE ANCHE LA SUA ROTAZIONE: «anche mentre gira» di una cosa spenta non vuol
// dire niente, e resterebbe scritto nella scena pronto a rispuntare. Il contrario — la rotazione senza il
// modello fermo — il motore non lo conosce (`inRotationEnabled` vale solo con `enabled`), e la cella resta spenta.
export const withAntiAliasCell = (config: AntiAliasConfig, device: keyof AntiAliasConfig, field: keyof AntiAliasDevice, value: boolean): AntiAliasConfig => {
    const current = config[device];
    const next: AntiAliasDevice =
        field === 'enabled' ? { enabled: value, inRotationEnabled: value && current.inRotationEnabled } : { ...current, inRotationEnabled: value };
    return { ...config, [device]: next };
};
